import { Column } from "../decorators/column";
import { autoserializeAs } from "cerializr";

export class NoOfPatientsInPathwayAReport {
    @autoserializeAs(String)
    @Column({
        columnName: 'Age'
    })
    age: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Count'
    })
    count: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Percent'
    })
    percent: string;
}
